<template>
  <div class="Home" v-title data-title="首页" :class="menuList.length>8?'pt7':'home-padding'">
    <div class="row align-items-center padding10" :class="menuList.length>1?'':'justify-content-center'">
      <div class="col-12 padding2" v-for="menu in menuList" :key="menu.name">
        <div class="menu-item fc-primary-dark" @click="menuClick(menu)">{{menu.name}}</div>
      </div>
    </div>
    <div v-if="menuList.length>0" :class="menuList.length>8?'pt7':'home-padding'"><van-button type="info" @click="logout" class="btn-primary">退 出</van-button></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Base64 } from 'js-base64';
import { sendRequest, getUserMenu } from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

export default Vue.extend({
  name: 'UserHome',
  components: {},
  data() {
    return {
      menuList: [],
    };
  },
  methods: {
    getMenu() {
      sendRequest(getUserMenu).then((menuList = []) => {
        storage.local.set('M_L', menuList);
        this.menuList = menuList;
      });
    },
    menuClick({ route, code }) {
      if (code === 'EXPORT') {
        this.exportData();
        return;
      }
      if (!route) {
        return;
      }
      const query = {};
      if (route === 'QuotationEdit') {
        query.quoteType = code.split('_')[1];
      } else if (code === 'SOTCK') {
        const type = storage.local.get('type');
        if (type !== 1) {
          this.$router.push('/stock/info/edit');
          return;
        }
      }
      this.$router.push({ name: route, query });
    },
    back() {
      this.$router.push('/home');
    },
    exportData(e = {}) {
      this.$router.push('/download/price');
      // this.$dialog.confirm({
      //   title: '确认',
      //   message: '确定立即下载当日报价信息吗？',
      // }).then(() => {
      //   const token = storage.local.get('token') || '';
      //   const link = document.createElement('a');
      //   link.style.display = 'none';
      //   link.href = `${config.DOWNLOAD_DOMAIN}/api/quote/report?token=${token}`;
      //   console.log(link.href);
      //   // 获取文件名
      //   // download 属性定义了下载链接的地址而不是跳转路径
      //   link.setAttribute('download', '今日报价.xlsx');
      //   document.body.appendChild(link);
      //   link.click();
      // }).catch(() => {
      //   // on cancel
      // });
    },
    logout() {
      storage.local.set('token', '');
      storage.local.set('type', '');
      storage.local.set('M_L', []);
      const companyId = storage.local.get('C_ID') || '';
      const link = companyId ? `/${Base64.encodeURL(`_${companyId || ''}`)}` : '';
      this.$router.push(`${link}/login`);
    },
  },
  created() {
    this.getMenu();
  },
});
</script>
<style scoped>
.Home {
  min-height: 100vh;
  background-image: url('../../assets/bg1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 30px;
}
.home-padding {
  padding-top: 10vh;
}
.menu-item {
  background-color: #eaeafe;
  border-radius: 6px;
  padding: 15px;
}
</style>
